/* custom define */
export const color_red = '#E93D34';
export const color_primary = '#52c41a'; 
export const color_white = '#fff';

